/* eslint-disable @typescript-eslint/no-explicit-any */
import { useAppSelector } from "@/src/app/hooks";
// import { Modal } from "@/src/components/Modal/Modal";
import { textVariants } from "@/src/components/Text/Text";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/src/components/shad/card";
import { CheckEnablers } from "@/src/hooks/check-enablers";
import { UserCheckIcon } from "lucide-react";
import userIcon from "@assets/icons/userIcon.svg";
import userCard from "@assets/icons/userCard.svg";
import check from "@assets/icons/checksign.svg";
import { Button } from "@/src/components/Button/Button";
import Loader from "@/src/components/Loader";
import kycImage from "@assets/nobgkycmany.png";
import { useTranslation } from "react-i18next";

const Verifications = () => {
  const { t } = useTranslation();
  const trans = (key: string) => t(`app.settings.verifications.${key}`);
  const { user } = useAppSelector((state) => state?.user);
  const { data, isLoading } = CheckEnablers("kyc");

  function verifyKyc() {
    window.location.assign(
      `${data?.info?.url}?token=${user?.token}&redirect_url=${window.location.href}`
    );
  }

  if (isLoading) return <Loader />;

  return (
    <div>
      <Card>
        <CardHeader>
          <CardTitle>{trans("header")}</CardTitle>
          <CardDescription>{trans("desc")}</CardDescription>
        </CardHeader>
        <CardContent className="grid gap-3 divide-y">
          {data?.info === "Verified" ? (
            <div className="flex items-center justify-between pt-2">
              <div className="grid">
                <span className={textVariants()}>
                  {trans("items.kyc.title")}
                </span>
                {data?.info === "Verified" ? (
                  <span
                    className={textVariants({ size: "sm", variant: "desc" })}
                  >
                    {trans("items.kyc.verified")}
                  </span>
                ) : (
                  <span
                    className={textVariants({ size: "sm", variant: "desc" })}
                  >
                    {data?.info}
                  </span>
                )}
              </div>
              {data?.info === "Verified" && (
                <UserCheckIcon className="h-6 w-6 text-green-500" />
              )}
              {/* {(data?.info === "Not Verified" || data?.info === "Rejected") && (
              <span
                // onClick={verifyKyc}
                onClick={() => setVerifyOpen(true)}
                className="text-sm text-red-500 cursor-pointer"
              >
                Verify
              </span>
            )} */}
              {data?.info === "Pending" && (
                <span className="text-sm text-yellow-500 ">
                  {trans("states.pending")}
                </span>
              )}
            </div>
          ) : (
            <div>
              <div className="grid md:grid-cols-2 gap-5">
                <div>
                  <h3 className={textVariants({ size: "lg" })}>
                    {trans("verify.requirements.header")}
                  </h3>
                  <div className="grid gap-3">
                    <div className="flex gap-2">
                      <img src={userCard} alt="" className="h-7 w-7" />
                      <div className="grid">
                        <span className={textVariants()}>
                          {trans("verify.requirements.identity.title")}
                        </span>
                        <span
                          className={textVariants({
                            size: "sm",
                            variant: "desc",
                          })}
                        >
                          {trans("verify.requirements.identity.desc")}
                        </span>
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <img src={userIcon} alt="" className="h-7 w-7" />
                      <div className="grid">
                        <span className={textVariants()}>
                          {trans("verify.requirements.selfie.title")}
                        </span>
                        <span
                          className={textVariants({
                            size: "sm",
                            variant: "desc",
                          })}
                        >
                          {trans("verify.requirements.selfie.desc")}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-[#EDF0FA] dark:bg-grey-500 px-4 py-2 rounded-md">
                  <h2 className={textVariants({ size: "lg", font: "medium" })}>
                    {trans("verify.features.header")}
                  </h2>
                  <div className="grid gap-2">
                    <div className="flex justify-between items-center">
                      <span className={textVariants({ variant: "desc" })}>
                        {trans("verify.features.p2p.label")}
                      </span>
                      <span className={textVariants()}>
                        {trans("verify.features.p2p.val")}
                      </span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className={textVariants({ variant: "desc" })}>
                        {trans("verify.features.withdraw.label")}
                      </span>
                      <span className={textVariants()}>
                        {trans("verify.features.withdraw.val")}
                      </span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className={textVariants({ variant: "desc" })}>
                        {trans("verify.features.deposit.label")}
                      </span>
                      <span className={textVariants()}>
                        {trans("verify.features.deposit.val")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid mt-5 gap-4">
                <div className="grid gap-1">
                  <h3 className={textVariants({ size: "xl" })}>
                    {trans("begin.label")}
                  </h3>
                  <div className="bg-[#FFF3E5] dark:bg-grey-500 rounded-lg text-[#F9AA4B] dark:text-grey-200 text-sm p-2 ">
                    {trans("begin.desc")}
                  </div>
                </div>
                <div className="bg-[#EDF0FA] dark:bg-grey-500 rounded-md ">
                  <img src={kycImage} alt="" className="w-full" />
                </div>
                <div className="grid gap-1">
                  <h2 className={textVariants({ size: "xl" })}>
                    Verification Guidelines
                  </h2>
                  <div className="grid gap-2">
                    <div className="flex items-center gap-1">
                      <img src={check} className="h-5 w-5" alt="" />
                      <span
                        className={textVariants({
                          size: "sm",
                          variant: "desc",
                        })}
                      >
                        {trans("guidelines.items.1")}
                      </span>
                    </div>
                    <div className="flex items-center gap-1">
                      <img src={check} className="h-5 w-5" alt="" />
                      <span
                        className={textVariants({
                          size: "sm",
                          variant: "desc",
                        })}
                      >
                        {trans("guidelines.items.2")}
                      </span>
                    </div>
                    <div className="flex items-center gap-1">
                      <img src={check} className="h-5 w-5" alt="" />
                      <span
                        className={textVariants({
                          size: "sm",
                          variant: "desc",
                        })}
                      >
                        {trans("guidelines.items.3")}
                      </span>
                    </div>
                  </div>
                </div>
                <Button
                  onClick={verifyKyc}
                  className="lg:w-2/5 md:w-3/5 py-3 md:mt-8"
                >
                  {trans("startButton")}
                </Button>
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default Verifications;
